import { AfterContentInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Angulartics2Marketo } from 'app/analytics/angulartics2-marketo';
import { Angulartics2Mixpanel } from 'app/analytics/angulartics2-mixpanel';
import { ServiceType } from 'app/core/service-type.model';
import { WizardUploadComponent } from 'app/orders/wizard/upload/upload.component';
import { WizardService } from 'app/orders/wizard/wizard.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { UILensService } from 'app/ui/lens/lens.service';
import { AccountService } from 'app/user/account.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { WelcomeCaptureComponent } from 'app/welcome/capture/capture.component';
import { filter, first } from 'rxjs/operators';
import { ApplicationsService } from '../applications/applications.service';
var DocumentsComponent = /** @class */ (function () {
    function DocumentsComponent(angulartics2Marketo, angulartics2Mixpanel, _accountService, _applicationsService, _dialogService, _router, _userSettingsService, _wizardService, _uiLensService) {
        var _this = this;
        this._accountService = _accountService;
        this._applicationsService = _applicationsService;
        this._dialogService = _dialogService;
        this._router = _router;
        this._userSettingsService = _userSettingsService;
        this._wizardService = _wizardService;
        this._uiLensService = _uiLensService;
        this.ServiceType = ServiceType;
        this.verificationUrl = '/verification';
        this.uploadFiles = function (files) {
            var isDemoApplication = !_this._applicationsService.defaultApplication().isCustomized;
            var isDocumentCapture = _this.serviceType === ServiceType.DocumentCapture;
            if (isDemoApplication && isDocumentCapture) {
                return;
            }
            if (files && files.length) {
                _this._wizardService.upload(files);
                _this.openWizard();
            }
        };
        this.openWizard = function () {
            _this._dialogService.open(WizardUploadComponent, {
                data: {
                    skipCreateDialog: _this._userSettingsService.rememberImportSettings,
                    showSettings: _this._userSettingsService.rememberImportSettings
                }
            });
        };
        this._userSettingsService.serviceType = this._router.url.indexOf('documents') === -1
            ? ServiceType.InvoiceCapture
            : ServiceType.DocumentCapture;
    }
    Object.defineProperty(DocumentsComponent.prototype, "allowDataCapture", {
        get: function () {
            return this._accountService.account.allowDataCapture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentsComponent.prototype, "serviceType", {
        get: function () {
            return this._router.url.indexOf('documents') === -1
                ? ServiceType.InvoiceCapture
                : ServiceType.DocumentCapture;
        },
        enumerable: true,
        configurable: true
    });
    DocumentsComponent.prototype.ngOnDestroy = function () {
        this._userSettingsService.showBackground = false;
    };
    DocumentsComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (!this._userSettingsService.welcomeTraining &&
            this._userSettingsService.visibleInvoicesUploadArea) {
            this._router.events
                .pipe(filter(function (event) { return event instanceof NavigationEnd; }), first())
                .subscribe(function () {
                _this._uiLensService.open(WelcomeCaptureComponent, 'capture');
            });
        }
    };
    return DocumentsComponent;
}());
export { DocumentsComponent };
